import apiClient from '../utils/apiClient';

const BACKEND_URL = '/main/api';
const RESUME_BASE_URL = `/resume`;

export const resumeService = {
  baseURL: BACKEND_URL,

  // Session Management
  async startSession(templateId = 1) {
    const response = await apiClient.post(`${RESUME_BASE_URL}/start-session`, {
      template_id: templateId,
    });
    return response.data;
  },

  async getSession(sessionId) {
    const response = await apiClient.get(`${RESUME_BASE_URL}/session/${sessionId}`);
    return response.data;
  },

  // AI Conversation
  async sendMessage(sessionId, message) {
    const response = await apiClient.post(
      `${RESUME_BASE_URL}/session/${sessionId}/conversation`,
      { message }
    );
    return response.data;
  },

  // Templates
  async getTemplates() {
    try {
      const response = await apiClient.get(`${RESUME_BASE_URL}/templates`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch templates:', error);
      // Return a default template if the API fails
      return [
        {
          id: 1,
          name: 'Professional',
          description: 'Clean and modern design suitable for most industries',
          preview_image_url: null,
          is_premium: false,
        },
      ];
    }
  },

  async getTemplate(templateId) {
    const response = await apiClient.get(`${RESUME_BASE_URL}/templates/${templateId}`);
    return response.data;
  },

  // PDF Generation
  async generatePDF(sessionId, templateId, title = 'My Resume') {
    const response = await apiClient.post(
      `${RESUME_BASE_URL}/session/${sessionId}/generate-resume-pdf`,
      {
        template_id: templateId,
        title,
      }
    );
    return response.data;
  },

  // Structured section submission (form wizard)
  async submitSection(sessionId, sectionType, content, { rawText = null, isAiEnhanced = false } = {}) {
    const response = await apiClient.post(`${RESUME_BASE_URL}/session/${sessionId}/section`, {
      section_type: sectionType,
      content,
      raw_text: rawText,
      is_ai_enhanced: isAiEnhanced,
    });
    return response.data;
  },

  async getProgress(sessionId) {
    const response = await apiClient.get(`${RESUME_BASE_URL}/session/${sessionId}/progress`);
    return response.data;
  },

  // AI content enhancement for a single field/section
  async enhanceContent(sessionId, sectionType, currentContent, { jobDescription = null, targetKeywords = [] } = {}) {
    const response = await apiClient.post(`${RESUME_BASE_URL}/session/${sessionId}/enhance`, {
      section_type: sectionType,
      current_content: currentContent,
      enhancement_type: 'improve',
      target_keywords: targetKeywords,
      job_description: jobDescription,
    });
    return response.data;
  },

  async getUserResumes() {
    const response = await apiClient.get(`${RESUME_BASE_URL}/user/resumes`);
    return response.data;
  },

  // Authenticated PDF download; returns an object URL the caller must revoke
  async downloadResumePdf(sessionId) {
    const response = await apiClient.get(`${RESUME_BASE_URL}/session/${sessionId}/download`, {
      responseType: 'blob',
    });
    return window.URL.createObjectURL(response.data);
  },

  // ATS Optimization
  async analyzeATS(jobDescription, resumeVersionId) {
    const response = await apiClient.post(`${RESUME_BASE_URL}/analyze-ats`, {
      job_description: jobDescription,
      resume_version_id: resumeVersionId,
    });
    return response.data;
  },

  // File Upload
  async uploadResume(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(`${RESUME_BASE_URL}/upload-resume`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

export default resumeService;